
<template>
  <div class="pagination">
    <el-button
      type="button"
      class="my-btn"
      @click="jumpFirstPage"
      v-if="pageSize > 6"
      >首页</el-button
    >
    <el-pagination
      ref="pagination"
      background
      prev-text="上一页"
      next-text="下一页"
      :layout="layout"
      @current-change="handleCurrentChange"
      :current-page="curPage"
      :total="total"
      :page-size="pageSize"
      style="display: inline-block; padding-left: 0px"
    >
    </el-pagination>
    <el-button
      type="button"
      class="my-btn"
      style="margin: 0px 5px"
      @click="jumpLastPage"
      v-if="pageSize > 6"
      >尾页</el-button
    >
    <el-button
      type="button"
      class="my-btn"
      style="margin: 0px 5px"
      v-if="pageSize > 6"
      >当前{{ curPage }}/{{ pageCount }} 共{{ total }}条</el-button
    >
  </div>
</template>

<script>
export default {
  props: {
    pageCount: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: window.screen.width < 720 ? 6 : 10,
    },
  },
  data() {
    return {
      curPage: 1,
      show: true,
      layout: "prev, pager, next, slot",
    };
  },
  computed: {
    middlePages() {
      if (this.pageCount <= 2) {
        return 0;
      } else if (this.pageCount > 2 && this.pageCount <= 10) {
        return this.pageCount - 2;
      } else {
        return this.curPage > 999 ? 5 : 8;
      }
    },
    bigLimit() {
      return this.middlePages > 5 ? this.pageCount - 6 : this.pageCount - 3;
    },
    offset() {
      if (this.curPage <= 5) {
        return 2;
      } else if (this.curPage >= this.bigLimit) {
        return this.bigLimit - 2;
      } else {
        return this.middlePages > 5 ? this.curPage - 3 : this.curPage - 2;
      }
    },
  },
  created() {
    if (window.screen.width < 720) {
      this.pageSize = 6;
      this.layout = "pager";
    } else {
      this.layout = "prev, pager, next, slot";
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit("togglePage", val);
    },
    jumpFirstPage() {
      this.$refs.pagination.handleCurrentChange(1);
      this.handleCurrentChange(1);
    },
    jumpLastPage() {
      this.$refs.pagination.handleCurrentChange(this.pageCount);
      this.handleCurrentChange(this.pageCount);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" >
.pagination {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;

  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 50px;

  .my-btn {
    span {
      font-size: 16px;
      color: #00479d !important;
    }
  }
  .el-pagination {
    button {
      padding: 6px 15px;
      font-size: 16px;
    }
    .el-pager {
      li {
        height: 42px;
        line-height: 42px;
        font-size: 16px;
        color: #00479d;
        background: none !important;
        font-size: 16px;

        width: auto;
        border: 1px solid #e8e8e8;
        padding: 0 25px;
        font-weight: 500;
      }
      li:hover {
        color: #00479d;
        border-color: #b3c8e2;
        background-color: #e6edf5 !important;
      }
      .active {
        color: #fff;
        background: #00479d !important;
      }
      .active:hover {
        color: #fff;
        background: #00479d !important;
      }
    }
    .btn-prev,
    .btn-next {
      background: none !important;
      padding: 0 15px;
      color: #00479d;
    }
    .btn-prev:hover,
    .btn-next:hover {
      color: #00479d;
      border-color: #b3c8e2;
      background-color: #e6edf5 !important;
    }
  }

  .el-pagination {
    button {
      border: 1px solid #e8e8e8;
      height: 42px;
      line-height: 42px;
      font-weight: 500;
      font-size: 16px;
      background: none;
      span {
        font-weight: 500;
        height: 42px;
        font-size: 16px;
        line-height: 42px;
        background: none;
      }
    }
  }
}
@media only screen and (max-width: 728px) {
  .pagination {
    margin-top: 30px;
    margin-bottom: 30px;
    .my-btn {
      span {
        font-size: 0.8rem;
      }
    }
    .el-pagination {
      button {
        padding: 3px 5px;
        font-size: 0.8rem;
      }
      .el-pager {
        li {
          height: 38px;
          line-height: 38px;
          font-size: 0.8rem;
          color: #00479d;
          width: auto;
          border: 1px solid #e8e8e8;
          padding: 0 6px;
          font-weight: 500;
        }
        li:hover {
        }
        .active {
        }
        .active:hover {
        }
      }
      .btn-prev,
      .btn-next {
        background: none !important;
        padding: 0 6px;
        color: #00479d;
      }
      .btn-prev:hover,
      .btn-next:hover {
        color: #00479d;
        border-color: #b3c8e2;
        background-color: #e6edf5 !important;
      }
    }

    .el-pagination {
      button {
        border: 1px solid #e8e8e8;
        height: 38px;
        line-height: 38px;
        font-weight: 500;
        font-size: 0.8rem;
        background: none;
        span {
          font-weight: 500;
          height: 38px;
          font-size: 0.8rem;
          line-height: 38px;
          background: none;
        }
      }
    }
  }
}
</style>